import React from 'react';
import { useIntl } from 'react-intl';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import withObjectBrowser from '@plone/volto/components/manage/Sidebar/ObjectBrowser';

import { mpfSubHomeDestaqueSchema } from './schema';

/**
 * Formulário da barra lateral. Sob `withObjectBrowser` porque o campo Destino
 * de cada atalho é um `object_browser` aninhado num `object_list`.
 */
const Data = (props) => {
  const { block, blocksConfig, data, onChangeBlock } = props;
  const intl = useIntl();
  const schema = mpfSubHomeDestaqueSchema({
    intl,
    activeObject: props.activeObject,
    setActiveObject: props.setActiveObject,
  });

  const dataAdapter =
    blocksConfig?.[data['@type']]?.dataAdapter ??
    (({ block: b, data: d, id, onChangeBlock: onChange, value }) =>
      onChange(b, { ...d, [id]: value }));

  return (
    <BlockDataForm
      {...props}
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) =>
        dataAdapter({ block, data, id, onChangeBlock, value })
      }
      onChangeBlock={onChangeBlock}
      formData={data}
      block={block}
    />
  );
};

export default withObjectBrowser(Data);
